// extracted by mini-css-extract-plugin
module.exports = {"desc":"style_desc__w5_Bn","title":"style_title__7l9P1"};